/** Convert Slack mrkdwn to standard Markdown so MemoizedMarkdown can render it. */
export function slackMrkdwnToMarkdown(input: string): string {
  return input
    .replace(/<(https?:\/\/[^|>]+)\|([^>]+)>/g, "[$2]($1)") // <url|text> -> [text](url)
    .replace(/<(https?:\/\/[^>]+)>/g, "$1") // <url> -> url
    .replace(/<@([A-Z0-9]+)>/g, "@$1") // <@U123> -> @U123
    .replace(/<#[A-Z0-9]+\|([^>]+)>/g, "#$1") // <#C123|name> -> #name
    .replace(/~([^~\n]+)~/g, "~~$1~~") // ~strike~ -> ~~strike~~
    .replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, "$1**$2**") // *bold* -> **bold**
    .replace(/(^|[^_])_([^_\n]+)_(?!_)/g, "$1*$2*"); // _italic_ -> *italic*
}

/** Convert the small Telegram HTML subset to standard Markdown. */
export function telegramHtmlToMarkdown(input: string): string {
  return (
    input
      // Only http(s) hrefs become links — a `javascript:`/`data:` href falls
      // through to the generic tag-strip below, dropping the anchor entirely.
      .replace(/<a\s+href="(https?:\/\/[^"]+)">([^<]*)<\/a>/gi, "[$2]($1)")
      .replace(/<\/?(b|strong)>/gi, "**")
      .replace(/<\/?(i|em)>/gi, "*")
      .replace(/<\/?(s|strike|del)>/gi, "~~")
      .replace(/<\/?u>/gi, "")
      .replace(/<code>([^<]*)<\/code>/gi, "`$1`")
      .replace(/<pre>([^]*?)<\/pre>/gi, "```\n$1\n```")
      .replace(/<[^>]+>/g, "")
  ); // strip any remaining tags
}
